import useTransactionsApi from '~/services/apis/transactions'
import useWalletApi from '~/services/apis/wallet'

export default function useCardDetails() {
	const { generateCardReference, saveCard, removeCard } = useTransactionsApi()
	const { fetchWalletDetails } = useWalletApi()
	const { initialize } = usePaystack()

	const addCard = async () => {
		const cardRef = await generateCardReference()
		const { User, getWalletDetails } = useUser()

		if (cardRef?.data.transaction) {
			const transactionDetails = cardRef.data.transaction
			// Initialize Paystack Sdk
			const payStackRef = await initialize({
				amount: Math.abs(transactionDetails.amount as number),
				email: User?.customer?.email || '',
				firstName: User?.first_name || '',
				lastName: User?.last_name || '',
				reference: transactionDetails.transaction_id,
				channels: ['card']
			})

			if (payStackRef && payStackRef.reference) {
				const response = await saveCard({
					transaction_id: transactionDetails.transaction_id,
					wallet_id: getWalletDetails?.id || '',
					save_card: 'true',
					customer_id: User?.customer?.id || ''
				})
				if (response) {
					useNotification().alert({
						status: response.responseCode,
						message: response.responseText
					})
					fetchWalletDetails(0)
					return response.data
				}
			}
		}

		return null
	}
	const deleteCard = async (password: string, card_id: string) => {
		const response = await removeCard({ password, card_id })
		if (response?.data) {
			useNotification().alert({
				status: response.responseCode,
				message: response.responseText
			})
		}
		return response?.data || null
	}

	return {
		addCard,
		deleteCard
	}
}
